export const NO_RESULTS_PLACEHOLDER_TEXT = window.jQuery ? $.__('No results...') : 'No results...';
